.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: var(--gap);
}

.stat {
  padding: 14px;
  background: var(--surface);
  border: 1px solid var(--card-border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow);
}

.icon {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  margin-bottom: 10px;
  border: 1px solid var(--card-border);
  border-radius: var(--r-sm);
  background: var(--surface-sunken);
  color: var(--ink-soft);
}

.value {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}

.label {
  margin-top: 2px;
  font-size: 13px;
  color: var(--muted);
}
